import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  OnInit,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImmomioRadioGroupComponent } from '@immomio/ui/radio-group';
import { AddressPipe, ContractIconPipe, SelectContractBaseComponent } from '@resident-nx/shared';
import { TicketCreationService } from '../../../../../services';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-select-contract',
  templateUrl: './select-contract.component.html',
  styleUrl: './select-contract.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContractIconPipe,
    IconWebComponent,
    AddressPipe,
    ImmomioRadioGroupComponent,
    FormsModule,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SelectContractWebComponent extends SelectContractBaseComponent implements OnInit {
  contractChange = output();
  #ticketCreationService = inject(TicketCreationService);
  #destroyRef = inject(DestroyRef);

  public items = computed(() =>
    (this.contracts() ?? []).map(contract => ({
      label: contract.externalId ?? '',
      value: contract.id ?? '',
      contract,
    }))
  );

  override ngOnInit() {
    this.#ticketCreationService.form.controls.contract.valueChanges
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(contract => {
        this.contractChange.emit();
        this.selectContract(contract, false);
      });
  }

  public onContractSelected(contractId: string): void {
    const contract = (this.contracts() ?? []).find(entry => entry.id === contractId);
    if (contract) {
      this.#ticketCreationService.form.controls.contract.setValue(contract);
    }
  }
}
